import { render, staticRenderFns } from "./EmailDidYouMean.vue?vue&type=template&id=54a967c6&scoped=true&"
import script from "./EmailDidYouMean.vue?vue&type=script&lang=ts&"
export * from "./EmailDidYouMean.vue?vue&type=script&lang=ts&"
import style0 from "./EmailDidYouMean.vue?vue&type=style&index=0&id=54a967c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a967c6",
  null
  
)

export default component.exports